import { ref } from 'vue'
import { defineStore } from 'pinia'

export const useUIStore = defineStore('ui', () => {
  const isMenuOpen = ref(false)
  const isPopupOpen = ref(false)

  const toggleIsMenuOpen = () => (isMenuOpen.value = !isMenuOpen.value)

  return { isMenuOpen, isPopupOpen, toggleIsMenuOpen }
})
